import { render, staticRenderFns } from "./areaRecordingMonths.vue?vue&type=template&id=f942776a"
import script from "./areaRecordingMonths.vue?vue&type=script&lang=js"
export * from "./areaRecordingMonths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports